import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import Form from "react-validation/build/form";
import { connect } from "react-redux";
import { login } from "../actions/auth";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class Login extends Component {
    constructor(props) {
        super(props);
        this.handleAccessWallet = this.handleAccessWallet.bind(this);
        this.onChangemnemonic = this.onChangemnemonic.bind(this);
        this.state = { mnemonic: "", loading: false, errors: [] };
    }

    onChangemnemonic(e) {
        this.setState({ mnemonic: e.target.value });
    }

    handleAccessWallet(e) {
        e.preventDefault();
        const mnemonic = this.state.mnemonic.trim().replace(/\s\s+/g, " ");
        if (!mnemonic) {
            toast.error("Recovery phrase is required");
            return;
        }

        const words = mnemonic.split(" ");
        if (words.length !== 18 && words.length !== 12) {
            toast.error("Your recovery phrase must contain 12 or 18 words");
            return;
        }

        this.setState({ mnemonic, loading: true });
        const { dispatch, history } = this.props;
        dispatch(login(mnemonic))
            .then((resp) => {
                if (resp.code === 100) {
                    this.setState({ loading: false });
                    history.push("/dashboard/VSOL");
                    window.location.reload();
                } else {
                    toast.error(resp.msg);
                    this.setState({ loading: false });
                }
            })
            .catch(() => this.setState({ loading: false }));
    }

    render() {
        if (this.props.isLoggedIn) return <Redirect to="/dashboard/VSOL" />;

        return (
            <div className="nova-auth-page">
                <ToastContainer />
                <div className="nova-auth-glow nova-auth-glow-one" aria-hidden="true"></div>
                <div className="nova-auth-glow nova-auth-glow-two" aria-hidden="true"></div>
                <header className="nova-auth-header">
                    <a href="https://novawallet.co.uk" className="nova-wordmark" aria-label="Nova Wallet home">
                        <img src="../assets/images/NOVA-1.png" alt="Nova Wallet" />
                    </a>
                    <span className="nova-status"><i></i> Secure web wallet</span>
                </header>

                <main className="nova-auth-main">
                    <section className="nova-auth-intro">
                        <span className="nova-eyebrow">Your assets. Your control.</span>
                        <h1>The future of crypto is in your hands.</h1>
                        <p>Access, send and receive your assets from one secure wallet built for the real world.</p>
                        <div className="nova-auth-points">
                            <span><b>7+</b> crypto assets</span>
                            <span><b>Fast</b> global transfers</span>
                            <span><b>Private</b> recovery access</span>
                        </div>
                    </section>

                    <section className="nova-auth-card" aria-labelledby="wallet-access-title">
                        <div className="nova-auth-card-header">
                            <span className="nova-lock" aria-hidden="true">◆</span>
                            <div>
                                <span className="nova-eyebrow">Welcome back</span>
                                <h2 id="wallet-access-title">Access your wallet</h2>
                            </div>
                        </div>
                        <p className="nova-auth-help">Enter your 12 or 18-word recovery phrase to open your existing wallet.</p>
                        <Form onSubmit={this.handleAccessWallet}>
                            <div className="form-group">
                                <label className="lbl" htmlFor="mnemonic">Recovery phrase</label>
                                <textarea rows="5" className="form-control nova-phrase-input" id="mnemonic"
                                    autoComplete="off" autoCorrect="off" autoCapitalize="none" spellCheck="false"
                                    placeholder="Enter each word separated by a space"
                                    value={this.state.mnemonic} onChange={this.onChangemnemonic} />
                            </div>
                            <button className="btn nova-primary-button" disabled={this.state.loading}>
                                {this.state.loading && <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>}
                                <span>{this.state.loading ? "Opening wallet…" : "Access wallet"}</span>
                                {!this.state.loading && <span aria-hidden="true">→</span>}
                            </button>
                            <div className="nova-divider"><span>New to Nova?</span></div>
                            <Link to="/create-wallet" className="btn nova-secondary-button">Create a new wallet</Link>
                        </Form>
                        <p className="nova-security-note"><span aria-hidden="true">●</span> Never share your recovery phrase with anyone.</p>
                    </section>
                </main>

                <footer className="nova-auth-footer">
                    <span>© {new Date().getFullYear()} Nova Wallet</span>
                    <nav aria-label="Legal">
                        <a href="https://vsolidus.com/copyrightpolicy/" target="_blank" rel="noopener noreferrer">Privacy</a>
                        <a href="https://vsolidus.com/termsandconditions/" target="_blank" rel="noopener noreferrer">Terms</a>
                        <a href="https://www.vsolidusacademy.com" target="_blank" rel="noopener noreferrer">Help</a>
                    </nav>
                </footer>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { isLoggedIn } = state.auth;
    const { message } = state.message;
    return { isLoggedIn, message };
}

export default connect(mapStateToProps)(Login);
